// Any plugins you want to use has to be imported
// Detail plugins list see https://www.tinymce.com/docs/plugins/
// Custom builds see https://www.tinymce.com/download/custom-builds/

//const plugins = ['advlist colorpicker colorpicker contextmenu directionality save searchreplace spellchecker tabfocus table template textcolo']
const plugins = ['advlist colorpicker colorpicker contextmenu lists noneditable paste save tabfocus table textcolor textpattern']

export default plugins
